export const getPointsBounds = (
  points: Array<google.maps.LatLngLiteral | google.maps.LatLng>,
) => {
  const bounds = new google.maps.LatLngBounds();

  points.forEach((point) => {
    bounds.extend(point);
  });

  return bounds;
};

export const getPolygonBounds = (polygon: google.maps.Polygon) => {
  const path = polygon.getPath();

  if (!path) return new google.maps.LatLngBounds();

  return getPointsBounds(path.getArray());
};

export const getPolygonCenter = (polygon: google.maps.Polygon) => {
  return getPolygonBounds(polygon).getCenter();
};
